<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { Button } from '../../../../misc'

interface Emits {
  (e: 'finish'): void
}

const emit = defineEmits<Emits>()
const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center gap-6 px-4 py-8 text-center">
    <!-- 图标 -->
    <div class="h-20 w-20 flex items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30">
      <div class="i-solar:cloud-upload-bold-duotone text-5xl text-primary-500" />
    </div>

    <!-- 标题 -->
    <div class="flex flex-col gap-2">
      <h2 class="text-xl font-semibold">
        保护你的数据
      </h2>
      <p class="text-sm text-neutral-600 dark:text-neutral-400">
        你的聊天记录、角色卡片等数据存储在本地浏览器中。
        开启百度网盘备份后，换设备或清除浏览器数据也能轻松恢复。
      </p>
    </div>

    <!-- 说明卡片 -->
    <div class="w-full rounded-xl bg-blue-50 p-4 text-left dark:bg-blue-900/20">
      <div class="mb-2 flex items-center gap-2 text-sm text-blue-700 dark:text-blue-300">
        <div class="i-solar:info-circle-bold-duotone" />
        <span>如何开启</span>
      </div>
      <p class="text-sm text-blue-600 dark:text-blue-400">
        进入 <span class="rounded bg-blue-100 px-1.5 py-0.5 font-medium dark:bg-blue-900/40">我 → 设置 → 机体模块 → 百度网盘同步</span>，
        授权百度网盘即可开启自动备份。
      </p>
    </div>

    <!-- 按钮 -->
    <div class="mt-2 w-full">
      <Button
        class="w-full"
        variant="primary"
        :label="t('settings.dialogs.onboarding.finish')"
        @click="emit('finish')"
      />
    </div>
  </div>
</template>
